<template>
  <div>
    <v-card-title><span class="no-wrap" :class="{ 'text-body-1': small }">{{
      item.title
        }}</span></v-card-title>
    <v-card-subtitle>
      <p :class="{ 'text-body-2': small }" class="mt-1 no-wrap" v-html="item.description">

      </p>
      <p>
        <v-chip small :color="colorTagClass(item.tag)" class="mx-1">{{
          item.tag
        }}</v-chip>
      </p>
      <div class="d-flex justify-space-between">
        <v-chip small :color="colorClass(item.value)">{{ item.value }}</v-chip>
        <div>
          <v-btn class="ml-4 grey lighten-3 black--text" text x-small @click="$emit('edit', item.id)" v-if="
            currentUser && currentUser.uid === '4jd41CisaJZmDYMwCGMRhFclhXY2'
          ">
            Edit
          </v-btn>
          <v-btn class="ml-4 grey lighten-3 black--text" text x-small @click="$emit('delete', item.id)" v-if="
            currentUser && currentUser.uid === '4jd41CisaJZmDYMwCGMRhFclhXY2'
          ">
            Delete
          </v-btn>
        </div>
      </div>
      <div v-if="allowSelect">
        <v-icon class="ml-2 chk black--text" @click="$emit('select', item.id)"
          v-if="selected">mdi-checkbox-marked</v-icon>
        <v-icon class="ml-2 chk black--text" @click="$emit('select', id)" v-else>mdi-checkbox-blank-outline</v-icon>
      </div>
    </v-card-subtitle>
  </div>
</template>

<script>
// const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "UserFunctionalityForm",
  props: {
    source: {
      type: Array,
      default: () => [],
    },
    shortlist: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    id: String,
    allowSelect: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    me() {
      return this.source.find((x) => x.id === this.id);
    },
    title() {
      return this.me ? this.me.title : "";
    },
    description() {
      return this.me ? this.me.description : "";
    },
    value() {
      return this.me ? this.me.value : "";
    },
    ...mapState(["currentUser"]),
    selected() {
      return this.shortlist.find((x) => x.id === this.item.id);
    },
  },

  methods: {
    colorClass(val) {
      switch (val) {
        case "5":
          return "green accent-1";
        case "10":
          return "green accent-2";
        case "25":
          return "green accent-3";
        case "20":
          return "green accent-3";
        case "30":
          return "green accent-4";
        case "50":
          return "green accent-4";
      }
    },
    colorTagClass(val) {
      switch (val) {
        case "Current Sprint – Immediate":
          return "red white--text";
        case "Current Sprint - Priority":
          return "amber";
        case "Current Sprint":
          return "yellow";
        case "Next Sprint – Priority":
          return "purple white--text";
        case "Next Sprint":
          return "blue";
        case "Additional Scope":
          return "grey";
        case "Nice to have":
          return "blue";
        default:
          return "grey";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chk {
  background: none;
  color: black;
}

.selected {
  border: none;
}
</style>
